import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';

@Component({
  selector: 'app-integer-field',
  templateUrl: './integer-field.component.html',
  styleUrls: ['./integer-field.component.css']
})
export class IntegerFieldComponent extends FieldComponentAbstract implements OnInit {

 public intValue: number;
 @ViewChild('input')
 private inputElement: ElementRef;

  ngOnInit(): void {
    if (this.fieldValue.int_value != null)
      this.completed = true;
    this.intValue = this.fieldValue.int_value;
  }

 public handleChange(newNumber: string) {
   const value = Math.floor(Number(newNumber));
   (<HTMLInputElement>this.inputElement.nativeElement).value = String(value);
   this.fieldValue.int_value = value;
   this.onChange(this.fieldValue);
 }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/integer-field/integer-field.component.ts